<template>
	<div class="warehouseReceipt" v-loading="loading">
		<div class="warehouseReceipt-title">入库开单</div>
		<div class="warehouseReceipt-form">
			<el-form ref="form" :model="form" label-width="100px">
				<el-row :gutter="24">
					<el-col :span="6">
						<el-form-item label="入库日期" required>
							<el-date-picker v-model="form.date" type="date" placeholder="选择入库日期"
								value-format="yyyy-MM-dd" style="width: 100%;">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="入库仓库" required>
							<el-select v-model="form.warehouse_id" filterable placeholder="请选择入库仓库"
								style="width: 100%;">
								<el-option v-for="item in warehouseList" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="采购供应商" required>
							<el-select v-model="form.erp_supplier_id" filterable placeholder="请选择采购供应商"
								style="width: 100%;">
								<el-option v-for="item in supplierList" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="经办人" required>
							<el-input v-model="form.handler" placeholder="请输入经办人"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="备注">
							<el-input v-model="form.remark" placeholder="请输入备注"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="应付金额" required>
							<el-input v-model="form.amount" placeholder="请输入应付金额"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="是否结清" required>
							<el-radio-group v-model="form.settlemented_status">
								<el-radio :label="0">未结清</el-radio>
								<el-radio :label="1">已结清</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>

				</el-row>
			</el-form>
		</div>
		<div class="table">
			<div class="table-operation">
				<el-button type="warning" icon="el-icon-plus" @click.stop="addFn()">添加商品</el-button>
				<div style="margin:0 10px;display: inline;">
					<el-dropdown @command="handleExport">
						<el-button type="success">
							模板导入<i class="el-icon-arrow-down el-icon--right"></i>
						</el-button>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="0">导入数据</el-dropdown-item>
							<el-dropdown-item command="1">导出所有在售商品模板</el-dropdown-item>
							<el-dropdown-item command="2">导出今日配货商品模板</el-dropdown-item>
							<el-dropdown-item command="3">导出今日销售商品模板</el-dropdown-item>
						</el-dropdown-menu>

					</el-dropdown>
				</div>
			</div>
			<el-table :data="tableData" border :header-cell-style="{
				background: '#f5f7fa',
				fontWeight: 'bold',
				color: '#303133'
			}">
				<el-table-column label="商品名称" align="center" width="180">
					<template slot-scope="scope">
						<span>{{ scope.row.goods_name }}</span>
					</template>
				</el-table-column>
				<el-table-column label="商品主图" align="center">
					<template slot-scope="scope">
						<el-image style="width: 50px; height: 50px" :src="scope.row.goods_thumb"
							:preview-src-list="[scope.row.goods_pic]">
						</el-image>
					</template>
				</el-table-column>
				<el-table-column label="商品卖点" align="center">
					<template slot-scope="scope">
						<span>{{ scope.row.goods_intro }}</span>
					</template>
				</el-table-column>
				<el-table-column label="自定义属性" align="center">
					<template slot-scope="scope">
						<span>{{ scope.row.attribute }}</span>
					</template>
				</el-table-column>
				<el-table-column label="采购价" align="center">
					<template slot-scope="scope">
						<el-input v-model="scope.row.cost" placeholder="请输入商品采购价"
							@blur="blurInputCount(scope.row, 'table', 1)"
							@input="numberic(scope.row,'cost',$event)"></el-input>
					</template>
				</el-table-column>
				<el-table-column label="数量" align="center" width="180">
					<template slot-scope="scope">
						<el-input v-model="scope.row.count" placeholder="请输入商品采购数量"
							@blur="blurInputCount(scope.row, 'table', 2)"
							@input="numberic(scope.row,'count',$event)"></el-input>
					</template>
				</el-table-column>
				<el-table-column label="金额" align="center">
					<template slot-scope="scope">
						<el-input v-model="scope.row.amount" placeholder="请输入商品采购金额"
							@blur="blurInputCount(scope.row, 'table', 3)"
							@input="numberic(scope.row,'amount',$event)"></el-input>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center" width="160">
					<template slot-scope="scope">
						<el-button type="danger" size="mini" @click.stop="removeFn(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="warehouseReceipt-footer">
			<el-button type="success" @click.stop="confirmFn(1)">保存并查看</el-button>
			<el-button type="success" @click.stop="confirmFn(2)">保存并继续</el-button>
		</div>
		<!-- 新增编辑 -->
		<el-dialog title="添加商品" :visible.sync="dialogVisible" width="70%" :close-on-click-modal="false" v-el-drag-dialog
			@close="closeDialog">
			<div class="search" style="padding: 0;margin-bottom: 10px;">
				<div class="search-l">
					<div class="l-item">
						<div class="item-label">商品名称:</div>
						<div class="item-input">
							<el-input v-model="goodsVal" placeholder="请输入商品名称" />
						</div>
					</div>
					<div class="l-item">
						<el-button type="warning"
							@click.stop="goodsPage = 1, goodsLoading = true, goodsList()">搜索</el-button>
					</div>
					<i></i>
					<i></i>
					<i></i>
					<i></i>
				</div>
			</div>
			<div style="height:500px;" class="scrollbar">
				<el-scrollbar style="height:100%">
					<el-table :data="goodsData" border v-loading="goodsLoading" :header-cell-style="{
						background: '#f5f7fa',
						fontWeight: 'bold',
						color: '#303133'
					}" :header-cell-class-name="leftheaderStyle">
						<el-table-column type="selection" width="55" align="center">
							<template slot-scope="scope">
								<el-checkbox :value="scope.row.goodsChecked ? scope.row.goodsChecked : false"
									@change="goodsItemBox(scope.row, $event)">
								</el-checkbox>
							</template>
						</el-table-column>
						<el-table-column label="商品名称" align="center" width="180">
							<template slot-scope="scope">
								<span>{{ scope.row.goods_name }}</span>
							</template>
						</el-table-column>
						<el-table-column label="商品主图" align="center">
							<template slot-scope="scope">
								<el-image style="width: 50px; height: 50px" :src="scope.row.goods_pic"
									:preview-src-list="[scope.row.goods_pic]">
								</el-image>
							</template>
						</el-table-column>
						<el-table-column label="商品卖点" align="center">
							<template slot-scope="scope">
								<span>{{ scope.row.goods_intro }}</span>
							</template>
						</el-table-column>
						<el-table-column label="自定义属性" align="center">
							<template slot-scope="scope">
								<span>{{ scope.row.attribute }}</span>
							</template>
						</el-table-column>
						<el-table-column label="采购价" align="center">
							<template slot-scope="scope">
								<el-input v-model="scope.row.cost" placeholder="请输入商品采购价"
									@blur="blurInputCount(scope.row, 'dialog', 1)"
									:disabled="scope.row.goodsChecked ? false : true"
									@input="numberic(scope.row,'cost',$event)"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="数量" align="center">
							<template slot-scope="scope">
								<el-input v-model="scope.row.count" placeholder="请输入商品采购数量"
									@blur="blurInputCount(scope.row, 'dialog', 2)"
									:disabled="scope.row.goodsChecked ? false : true"
									@input="numberic(scope.row,'count',$event)"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="小计" align="center">
							<template slot-scope="scope">
								<el-input v-model="scope.row.amount" placeholder="请输入商品小计"
									@blur="blurInputCount(scope.row, 'dialog', 3)"
									:disabled="scope.row.goodsChecked ? false : true"
									@input="numberic(scope.row,'amount',$event)"></el-input>
							</template>
						</el-table-column>
					</el-table>
				</el-scrollbar>
			</div>
			<el-pagination class="page" @size-change="goodsPageNum = $event, goodsLoading = true, goodsList()"
				@current-change="goodsPage = $event, goodsLoading = true, goodsList()" :current-page="goodsPage"
				:page-sizes="goodsPageSizes" layout="total, sizes, prev, pager, next, jumper" :page-size="goodsPageNum"
				:total="goodsTotal">
			</el-pagination>
			<span slot="footer" class="dialog-footer">
				<el-button type="warning" @click.stop="dialogConfirmFn">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 上传文件 -->
		<el-dialog title="上传文件" :visible.sync="dialogUploadVisible" width="400px" :close-on-click-modal="false"
			v-el-drag-dialog @close="dialogUploadVisible = false">
			<el-upload class="upload-demo" drag :action="serverUrl" :headers="uploadHeaders"
				:data="{leader_member_id:form.leader_member_id}" :show-file-list="false"
				:on-success="handleUploadSuccess">
				<i class="el-icon-upload"></i>
				<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em>,只能上传xls/xlsx文件</div>
				<div class="el-upload__tip" slot="tip">{{excelTip}}</div>
			</el-upload>
			<span slot="footer" class="dialog-footer">
				<el-button @click.stop="dialogUploadVisible = false">取 消</el-button>
				<el-button type="primary" @click.stop="uploadConfirmFn" v-loading.fullscreen.lock="loading">确
					定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import CryptoJS from 'crypto-js'
	var timestamp = new Date().getTime()
	export default {
		data() {
			return {
				form: {
					date: '',
					warehouse_id: '',
					erp_supplier_id: '',
					handler: '',
					amount: '',
					remark: '',
					settlemented_status: 0
				},
				tableData: [],
				warehouseList: [], //仓库
				supplierList: [], //供应商
				// 新增、编辑
				dialogVisible: false,
				inputGoodsList: [],
				goodsVal: '',
				goodsData: [],
				goodsLoading: true,
				goodsPage: 1,
				goodsPageNum: 10,
				goodsTotal: 0,
				goodsPageSizes: [10, 50, 200, 1000],
				loading: false,
				dialogUploadVisible: false,
				serverUrl: '/erp/v1/export/parseFile',
				uploadHeaders: {
					token: window.sessionStorage.getItem('token'),
					sign: CryptoJS.MD5(sessionStorage.getItem('token') + 'w2MDYDE8nx4CQdA8fn2Nmnexn4bSyBbh' + timestamp)
						.toString(),
					timestamp: timestamp
				},
				excelTip: "",
				excelGoodsList: []
			}
		},
		mounted() {
			this.form.date = this.getCurrentDate()
			this.getWarehouse()
			this.getSupplierList()
			if (this.$route.query.id) {
				this.getDetails()
			}
		},
		methods: {
			// 获取当前年月日
			getCurrentDate() {
				const today = new Date();
				let year = today.getFullYear();
				let month = (today.getMonth() + 1).toString().padStart(2, '0');
				let day = today.getDate().toString().padStart(2, '0');
				return `${year}-${month}-${day}`;
			},
			uploadConfirmFn() {
				this.dialogUploadVisible = false
				this.excelTip = ""
				if (this.excelGoodsList.length > 0) {
					this.excelGoodsList.forEach(item => {
						item.cost = item.price
						this.goodsItemBox(item, true)
					})
					this.dialogConfirmFn()
				}

			},
			handleUploadSuccess(res, file) {
				if (res.code == 200) {
					this.excelTip = "共包含 " + res.data.length + ' 个商品（已忽略掉数量是 0 的商品）'
					this.excelGoodsList = res.data
				} else {
					this.excelTip = res.msg
					this.excelGoodsList = []
				}

			},
			handleExport(type) {
				if (type > 0) {
					this.goodsLoading = true
					this.$http.post(`/erp/v1/export/goodsTemplate`, {
						type: type,
						channel: 'rkd'
					}).then((res) => {
						const {
							code,
							data,
							msg
						} = res.data
						this.goodsLoading = false
						if (code == 200) {
							window.open(data.url, '_self')
						} else {
							this.$message.error(msg);
						}
					});
				} else {
					if (this.form.leader_member_id == 0) {
						this.$message.error("请先选择团长")
						return
					}
					this.dialogUploadVisible = true
				}

			},
			// 订单详情
			getDetails() {
				this.$http.post(`/erp/v1/rkd/index`, {
					id: this.$route.query.id
				}).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					this.goodsLoading = false
					if (code == 200) {
						this.form.date = data.date
						this.form.warehouse_id = data.warehouse_id
						this.form.erp_supplier_id = data.erp_supplier_id
						this.form.handler = data.handler
						this.form.amount = data.amount
						this.form.remark = data.remark
						this.form.settlemented_status = data.settlemented_status
						this.tableData = JSON.parse(JSON.stringify(data.order_goods).replace(/"goods_id"/g,
							'"id"'))
						setTimeout(() => {
							this.calculatePrice()
						}, 500);
					} else {
						this.$message.error(msg);
					}
				});
			},
			// 仓库
			getWarehouse() {
				this.$http.post(`erp/v1/warehouse/all_zong`, {
					pageNum: 100
				}).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					if (code == 200) {
						this.warehouseList = data
						if (this.warehouseList) {
							this.form.warehouse_id = this.warehouseList[0].id
						}
					} else {
						this.$message.error(msg);
					}
				});
			},
			// 供应商
			getSupplierList() {
				this.$http.post(`/erp/v1/supplier/all`).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					if (code == 200) {
						this.supplierList = data
					} else {
						this.$message.error(msg);
					}
				});
			},
			// 新增
			addFn() {
				if (!this.form.date) {
					this.$message.error('请选择入库日期');
					return
				}
				if (!this.form.warehouse_id) {
					this.$message.error('请选择仓库');
					return
				}
				if (!this.form.erp_supplier_id) {
					this.$message.error('请选择供应商');
					return
				}

				this.dialogVisible = true
				this.goodsList()

			},
			// 删除
			removeFn(item) {
				let index = this.tableData.indexOf(item)
				this.tableData.splice(index, 1)
				this.calculatePrice()
			},
			// 隐藏表头的选择框
			leftheaderStyle({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex === 0) {
					return "seltAllbtnDis"
				}
			},
			// 单个选择商品
			goodsItemBox(item, e) {
				let index = this.tableData.indexOf(item)
				if (e == true) {
					if (index >= 0) {
						return
					}
					this.$set(item, 'goodsChecked', true)
					this.tableData.push(item)
				} else {
					this.$set(item, 'goodsChecked', false)
					this.tableData.splice(index, 1)
				}
			},
			// 商品列表
			goodsList() {
				this.$http.post(`erp/v1/goods/lst`, {
					page: this.goodsPage,
					pageNum: this.goodsPageNum,
					key: this.goodsVal
				}).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					this.goodsLoading = false
					if (code == 200) {
						this.goodsData = data.rows
						this.goodsTotal = data.total
						this.goodsData.forEach(i => {
							this.$set(i, 'count', 1)
							this.$set(i, 'amount', Number(i.cost) * i.count)
							this.tableData.forEach(j => {
								if (i.id == j.id) {
									this.$set(i, 'cost', Number(j.amount / j.count).toFixed(2))
									this.$set(i, 'count', j.count)
									this.$set(i, 'amount', j.amount)
									this.$set(i, 'goodsChecked', true)
								}
							})
						})
					} else {
						this.$message.error(msg);
					}
				});
			},
			// 新增编辑商品确定
			dialogConfirmFn() {
				this.goodsVal = ''
				this.dialogVisible = false
				setTimeout(() => {
					this.calculatePrice()
				}, 500);
			},
			// 关闭弹窗
			closeDialog() {
				this.tableData = this.tableData.filter(item => item.count != undefined);
				setTimeout(() => {
					this.calculatePrice()
				}, 500);
			},
			// 计算价格
			calculatePrice() {
				this.inputGoodsList = []
				this.form.amount = 0
				this.tableData.forEach(item => {
					// lzc 修改
					if (item.amount != undefined){
						let price = Number(Number(item.amount) / item.count)
						this.$set(item, 'price', price.toFixed(2))
					}else{
						let amount = Number(item.price * item.count)
						this.$set(item, 'amount', amount.toFixed(2))
					}
					// 实收
					// lzc 修改
					this.form.amount += Number(item.amount)
					this.inputGoodsList.push({
						goods_id: item.id,
						count: item.count,
						price: item.cost,
						amount: item.amount
					})
				})
				this.form.amount = this.form.amount.toFixed(2)
			},
			// 操作商品数量
			blurInputCount(item, type, status) {
				if (status == 3) {
					this.$set(item, 'cost', Number(item.amount) / item.count)
					item.cost = item.cost.toFixed(2)
				} else {
					this.$set(item, 'amount', Number(Number(item.cost) * item.count).toFixed(2))
				}
				if (type == 'dialog') {
					this.tableData.forEach(i => {
						if (i.id == item.id) {
							i.cost = item.cost
							i.count = item.count
							i.amount = item.amount
						}
					})
				} else {
					setTimeout(() => {
						this.calculatePrice()
					}, 500);
				}
			},
			// 开单
			confirmFn(type) {
				if (!this.form.handler) {
					this.$message.error('请输入经办人');
					return
				}
				if (this.inputGoodsList.length <= 0) {
					this.$message.error('请选择商品');
					return
				}
				let that = this
				this.$confirm('此操作将生成采购入库订单,需要您确认入库后才会修改库存, 请问是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					that.$http.post(`erp/v1/rkd/add`, {
						...that.form,
						goods_list: JSON.stringify(that.inputGoodsList),
						source_order_id: that.$route.query.id ? that.$route.query.id : ''
					}).then((res) => {
						that.loading = false
						const {
							code,
							data,
							msg
						} = res.data
						if (code == 200) {
							if (type == 1) {
								that.$router.push("/warehouseManagement");
								// 存储路由
								sessionStorage.setItem('activeMenu', 'warehouseManagement');
								setTimeout(() => {
									window.location.reload();
								}, 1000)
							} else {
								that.$message.success('操作成功');
								setTimeout(() => {
									window.location.reload();
								}, 1000)
							}
						} else {
							that.$message.error(msg);
						}
					});
				}).catch(() => {
					that.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			numberic: function(item, keyname, event) { // type 为number //item 为json对象，keyname为键值，event为事件对象.两位小数
				var value = item[keyname];
				var zeroFirst = value.indexOf(0);
				var dot = value.indexOf('.');
				var vlen = value.length

				if (value.indexOf('.') == 0) {
					alert("value.indexOf('.'):" + value.indexOf('.'));
					alert("请输入合法的数字!");
					item[keyname] = 0;
				}
				if (zeroFirst == 0) { //首位为0,第二位则必须为.
					if (vlen >= 3 && value.indexOf('.') == 1) {
						if (value.length > 4) {
							item[keyname] = value.substr(0, vlen - 1);
							alert("最多两位小数!");
						} else {
							if (isNaN(Number(value[vlen - 1]))) {
								item[keyname] = value.substr(0, vlen - 1);
								alert("请输入合法的数字!");
							}
						}
					} else if (vlen == 2 && value.indexOf('.') != 1) {
						alert("请输入小数点！");
						item[keyname] = 0;
					}
				} else {
					if (dot > -1 && dot + 1 != vlen) { //已输入小数点
						if (isNaN(Number(value[vlen - 1]))) { //小数点后只能输入0-9
							item[keyname] = value.substr(0, vlen - 1);
							alert("请输入合法的数字0-9!");
						} else if (vlen - dot > 2 + 1) {
							item[keyname] = value.substr(0, vlen - 1);
							alert("最多两位小数!");
						}
					} else if (dot == -1) {

					}
				}
			}
		},
	}
</script>
<style lang="scss" scoped>
	.warehouseReceipt {
		.warehouseReceipt-title {
			text-align: center;
			font-size: 30px;
			margin-bottom: 20px;
		}

		.warehouseReceipt-form {
			background: #fff;
			padding: 30px 20px 10px 20px;
			border-radius: 10px;
			margin-bottom: 20px;
		}

		.warehouseReceipt-footer {
			display: flex;
			justify-content: center;
			margin-top: 30px;
		}
	}

	.page {
		margin-top: 20px;
		text-align: right;
	}
</style>